import snakeCase from 'lodash/snakeCase'
import mapKeys from 'lodash/mapKeys'
import { defineStore } from 'pinia'

const formInitState = {
  content: '',
  userContact: {
    firstName: '',
    lastName: ''
  },
  user: {
    email: '',
    password: '',
    terms_of_service: false
  }
}

export const useMainStore = defineStore('main', {
  state: () => {
    return {
      form: { ...formInitState },
      loggedUser: null,
      conversation: null,
      errors: {},
      error: ''
    }
  },
  actions: {
    resetErrors() {
      this.errors = {}
      this.error = ''
    },
    resetForm() {
      this.resetErrors()
      this.form = { ...formInitState }
    },
    resetAll() {
      this.resetForm()
      this.loggedUser = null
      this.conversation = null
    }
  },
  getters: {
    signupParams: state => {
      const contactAttributes = mapKeys(state.form.userContact, (v, k) => snakeCase(k))
      return {
        user: {
          ...state.form.user,
          role: 'client',
          from_fast_contact: true,
          user_contact_attributes: { ...contactAttributes }
        }
      }
    },
    loginParams: state => {
      return {
        user: state.form.user
      }
    },
    errorsFor: state => {
      return field => {
        return state.errors[field]
      }
    }
  }
})
